/* unplugin-vue-components disabled */import { render } from "./warehouse-area.vue?vue&type=template&id=a447df2c"
import script from "./warehouse-area.vue?vue&type=script&lang=js"
export * from "./warehouse-area.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/amoeba-logistics-information-system-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__